const moduleVoteMask = {
	namespaced: true,
	state: {
        MASK_ACTIVE: false,
        WORKS_INFO: "" 
	},
	mutations: {
        SET_MASK_ACTIVE: (state, params) => {
            state.MASK_ACTIVE = params
        },
        SET_WORKS_INFO: (state, params) => {
            state.WORKS_INFO = params
        }
	},
	actions: {
        VOTE({ commit }, params) {
            commit("SET_MASK_ACTIVE", true)
            commit("SET_WORKS_INFO", params)
        }
	},
	getters: {
	}
}

export default moduleVoteMask
